import { Button } from '@/components/Button';
import stop from '/icons/StopCircle.svg';
import { Modal, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react';

interface LogoutModalProps {
  isOpen: boolean; // Indicates whether the modal is open
  onOpenChange: (isOpen: boolean) => void; // Function to handle modal state change
  closePracticeModalPause: () => void; // Function to handle specific modal-related logic (no arguments, no return value)
}

const LogoutModal = ({ isOpen, onOpenChange, closePracticeModalPause }: LogoutModalProps) => {
  return (
    <Modal
      backdrop="opaque"
      isOpen={isOpen}
      onOpenChange={closePracticeModalPause}
      size={'xl'}
      classNames={{
        backdrop: 'bg-gradient-to-t from-zinc-900/50 backdrop-opacity-20 backdrop-blur-sm',
        wrapper: 'custom-modal'
      }}
    >
      <ModalContent>
        {() => (
          <>
            <ModalBody className="text-center justify-center items-start pt-10 gap-0">
              <img src={stop} alt="User" width={120} height={120} className="m-auto" />
              <h3 className="text-xl text-darkBlue font-bold mt-2 px-0 lg:px-20">Are you sure you want to Logout?</h3>
            </ModalBody>
            <ModalFooter className="justify-center gap-3 flex items-start pb-4 flex-wrap">
              <Button label="Yes" onClick={() => onOpenChange(false)} className="py-3" />
              <Button label="No" variant="outline" onClick={closePracticeModalPause} className="py-3" />
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default LogoutModal;
